// Ops-console-specific formatters (switch values, scope, absolute timestamps).
// General formatters (relativeTime, num) live in ./format and are reused as-is.

/** 'client' when a switch row is client-readable, 'server' when server-only. */
export function scopeLabel(clientSafe: boolean): string {
  return clientSafe ? 'client' : 'server';
}

/** Compact, single-line rendering of a switch/audit jsonb value. */
export function formatValue(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'object') {
    const s = JSON.stringify(value);
    return s.length > 140 ? `${s.slice(0, 137)}…` : s;
  }
  return String(value);
}

/** Precise local timestamp; '—' for null/invalid. */
export function absoluteTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return '—';
  return t.toLocaleString();
}
